/**
 * Utility functions for handling question responses
 */

/**
 * Formats multiple choice selections into alphabetically sorted comma-separated string
 * @param currentSelection - Current selected options as comma-separated string
 * @param newOption - Option to toggle
 * @returns Formatted selection string
 */
export const formatMultipleChoiceSelection = (currentSelection: string, newOption: string): string => {
    // Convert current selection to array
    const currentSelections = currentSelection ? currentSelection.split(',').filter(Boolean) : [];
    
    let updatedSelections: string[];
    if (currentSelections.includes(newOption)) {
        // Remove option if already selected
        updatedSelections = currentSelections.filter(sel => sel !== newOption);
    } else {
        // Add option if not selected
        updatedSelections = [...currentSelections, newOption];
    }
    
    // Sort alphabetically and join with comma
    return updatedSelections.sort().join(',');
};

/**
 * Checks if an option is selected in multiple choice question
 * @param selectedOptions - Comma-separated string of selected options
 * @param option - Option to check
 * @returns Boolean indicating if option is selected
 */
export const isOptionSelected = (selectedOptions: string, option: string): boolean => {
    return selectedOptions ? selectedOptions.split(',').includes(option) : false;
};

/**
 * Prepares question data for API submission
 * @param questionData - Question data object
 * @returns Formatted data for API submission
 */
export const prepareQuestionSubmission = (questionData: any) => {
    const { UserTestId, QuestionId, SelectedOption, IsFlag, QuestionTypeId } = questionData;
    
    let formattedSelection = SelectedOption;
    
    // For multiple choice questions (QuestionTypeId = 2), ensure proper formatting
    if (QuestionTypeId === 2 && SelectedOption) {
        const selections = SelectedOption.split(',').filter(Boolean);
        formattedSelection = selections.sort().join(',');
    }
    
    return {
        UserTestId,
        QuestionId,
        SelectedOption: formattedSelection || null,
        IsFlag: IsFlag || 0
    };
};